function identity(x) {
    return x;
}

export { identity };
//# sourceMappingURL=identity.js.map
